/**
 * Utility to manage model settings in localStorage.
 */
let modelSettings = null;
let settingsRequest = null;

export const loadModelSettings = (axios) => {
  if (modelSettings) return Promise.resolve(modelSettings);
  if (!settingsRequest) {
    settingsRequest = axios.get('/chatting/models').then(response => {
      const settings = response.data.data;
      if (!settings.models?.some(model => model.value === settings.defaultModel && model.available)) {
        throw new Error('사용 가능한 기본 모델이 없습니다.');
      }
      modelSettings = settings;
      setChatModel(getChatModel());
      setReasoningEffort(getReasoningEffort());
      return settings;
    }).finally(() => { settingsRequest = null; });
  }
  return settingsRequest;
};

export const getSqlModel = () => {
  return localStorage.getItem("sqlModel") || 'qwen3-coder-next:q4_K_M';
};

export const setSqlModel = (model) => {
  localStorage.setItem("sqlModel", model);
};

export const getLlmTarget = () => {
  const target = localStorage.getItem('llmTarget');
  return ['gemini', 'openai'].includes(target) ? target : 'on-premise';
};

export const getChatModel = () => {
  const target = getLlmTarget();
  const saved = target === 'on-premise' ? getSqlModel() : target;
  if (!modelSettings) return saved;
  return modelSettings.models.find(model => model.value === saved && model.available)?.value || modelSettings.defaultModel;
};

export const setChatModel = (value) => {
  const model = modelSettings?.models.find(model => model.value === value && model.available);
  if (!model) return;
  localStorage.setItem('llmTarget', model.target);
  if (model.target === 'on-premise') setSqlModel(model.value);
};

export const getReasoningEffort = (modelValue = getChatModel()) => {
  const effort = localStorage.getItem('reasoningEffort');
  const model = modelSettings?.models.find(model => model.value === modelValue);
  return model?.reasoningEfforts.includes(effort) ? effort : (model?.defaultReasoningEffort || 'medium');
};

export const setReasoningEffort = (effort) => localStorage.setItem('reasoningEffort', effort);

export const getTemperature = () => {
  return localStorage.getItem("temperature") ? parseFloat(localStorage.getItem("temperature")) : 0.7;
};

export const setTemperature = (temp) => {
  localStorage.setItem("temperature", temp);
};

export const getIsThink = () => {
  return localStorage.getItem("isThink") === "true";
};

export const setIsThink = (think) => {
  localStorage.setItem("isThink", think);
};

export const getChatRequestSettings = async (axios) => {
  const settings = await loadModelSettings(axios);
  const model = settings.models.find(model => model.value === getChatModel());
  return {
    model: model.value,
    ...(model.temperatureSupported !== false ? { temperature: getTemperature() } : {}),
    isThink: model.thinkingRequired || (model.thinkingSupported && getIsThink()),
    ...(model.reasoningEfforts.length ? { reasoningEffort: getReasoningEffort(model.value) } : {})
  };
};
